import { useEffect, useState } from 'react'

const DEVELOPER_MODE_KEY = 'showPlaceholder'

export function useDeveloperMode() {
  const [isDeveloperMode, setIsDeveloperMode] = useState(() => {
    const stored = localStorage.getItem(DEVELOPER_MODE_KEY)
    return stored === 'true'
  })

  useEffect(() => {
    const handleStorageChange = () => {
      const stored = localStorage.getItem(DEVELOPER_MODE_KEY)
      setIsDeveloperMode(stored === 'true')
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  const toggleDeveloperMode = () => {
    const newValue = !isDeveloperMode
    localStorage.setItem(DEVELOPER_MODE_KEY, String(newValue))
    setIsDeveloperMode(newValue)
  }

  return { isDeveloperMode, toggleDeveloperMode }
}
